import { ClassLevelSubjectSettingApiResponse, ClassLevelSubjectSettingUpdatePayload } from "types/classLevelSubjectSettingTypes";
import axios from "./axiosInstance";

export const createClassLevelSubjectSetting = async (payload: {
  classLevelId: string;
  subjectId: string;
  numberHours: number;
}): Promise<ClassLevelSubjectSettingApiResponse> => {
  const response = await axios.post<ClassLevelSubjectSettingApiResponse>(`/class-level-subject-settings`, payload);
  return response.data;
};

export const updateClassLevelSubjectSetting = async (settingId: string, payload: Partial<ClassLevelSubjectSettingUpdatePayload>): Promise<ClassLevelSubjectSettingApiResponse> => {
  const response = await axios.put<ClassLevelSubjectSettingApiResponse>(`/class-level-subject-settings/${settingId}`, payload);
  return response.data;
};